import { CommonEnums } from '../../common.enums';

export class Dashboards_Inst_Cnd {
    dashboards_Inst_Cnd_Id: number;
    dashboards_Inst_Id: number;
    dxMp_Id: number;
    dashboardsCndNm: string;
    dashboardsCnd: string;
    valid_Cd: string;
    srt_Order: number;

    constructor() {
        this.setDefault();
    }

    setDefault() {
        this.dashboards_Inst_Cnd_Id = CommonEnums.defaults.LONG_VAL;
        this.dashboards_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.dashboardsCndNm = CommonEnums.defaults.STRING_EMPTY;
        this.dashboardsCnd = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.srt_Order = CommonEnums.defaults.LONG_VAL;
    }

    static parse(dashboards_Inst_CndTmp: Dashboards_Inst_Cnd): Dashboards_Inst_Cnd {
        let dashboards_Inst_Cnd: Dashboards_Inst_Cnd = new Dashboards_Inst_Cnd();
        dashboards_Inst_Cnd.copyFrom(dashboards_Inst_CndTmp);
        return dashboards_Inst_Cnd;
    }

    getPrimaryKey(): string {
        return this.dashboards_Inst_Id + '.' + this.dxMp_Id;
    }

    copy(): Dashboards_Inst_Cnd {
        let dashboards_Inst_CndTmp: Dashboards_Inst_Cnd = new Dashboards_Inst_Cnd();

        dashboards_Inst_CndTmp.dashboards_Inst_Cnd_Id = this.dashboards_Inst_Cnd_Id;
        dashboards_Inst_CndTmp.dashboards_Inst_Id = this.dashboards_Inst_Id;
        dashboards_Inst_CndTmp.dxMp_Id = this.dxMp_Id;
        dashboards_Inst_CndTmp.dashboardsCndNm = this.dashboardsCndNm;
        dashboards_Inst_CndTmp.dashboardsCnd = this.dashboardsCnd;
        dashboards_Inst_CndTmp.valid_Cd = this.valid_Cd;
        dashboards_Inst_CndTmp.srt_Order = this.srt_Order;

        return dashboards_Inst_CndTmp;
    }

    copyFrom(dashboards_Inst_CndTmp: Dashboards_Inst_Cnd): void {
        this.dashboards_Inst_Cnd_Id = dashboards_Inst_CndTmp.dashboards_Inst_Cnd_Id;
        this.dashboards_Inst_Id = dashboards_Inst_CndTmp.dashboards_Inst_Id;
        this.dxMp_Id = dashboards_Inst_CndTmp.dxMp_Id;
        this.dashboardsCndNm = dashboards_Inst_CndTmp.dashboardsCndNm;
        this.dashboardsCnd = dashboards_Inst_CndTmp.dashboardsCnd;
        this.valid_Cd = dashboards_Inst_CndTmp.valid_Cd;
        this.srt_Order = dashboards_Inst_CndTmp.srt_Order;
    }

    compare(dashboards_Inst_CndTmp: Dashboards_Inst_Cnd): string {
        let dashboards_Inst_CndString: string = this.toString(false);
        let dashboards_Inst_CndTmpString: string = dashboards_Inst_CndTmp.toString(false);

        if (dashboards_Inst_CndString != dashboards_Inst_CndTmpString) {
            return dashboards_Inst_CndString + ', ' + dashboards_Inst_CndTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Dashboards_Inst_Cnd [dashboards_Inst_Cnd_Id=" + this.dashboards_Inst_Cnd_Id + ", dashboards_Inst_Id=" + this.dashboards_Inst_Id +
            ", dxMp_Id=" + this.dxMp_Id + ", dashboardsCndNm=" + this.dashboardsCndNm + ", dashboardsCnd=" + this.dashboardsCnd +
            ", valid_Cd =" + this.valid_Cd + ", srt_Order =" + this.srt_Order ;

        if (isNotCompare) {
            str += ''
        }

        str += ']';

        return str;
    }
}